export default function copieReferencePersonalisee(arrayNewLignesCommande, ligneInitiale) {
  arrayNewLignesCommande.forEach(ligne => {
    ligne.referencePersonnalise = ligneInitiale.referencePersonnalise;
    if (ligne.lignesCommande) {
      ligne.lignesCommande.forEach(l => {
        l.referencePersonnalise = ligneInitiale.referencePersonnalise;
      });
    }
  });
}
